<template>
    <div>
        <ly-dialog2 v-model="dialogVisible" :title="loadingTitle" width="640px" :before-close="handleClose">
            
            <el-row style="margin-bottom: 10px; ">
                <el-col :span="24" style="height: 50px;display: flex; justify-content: center;">
                    <el-form>
                        <el-form-item style="width: 100%;">
                            <el-radio-group v-model="selectedOption">
                            <el-radio :label="1" style="font-size: 16px;padding-left: 35px;">忽略告警</el-radio>
                            <el-radio :label="2" style="font-size: 16px;padding-left: 35px;">确认告警</el-radio>
                            <el-radio :label="3" style="font-size: 16px;padding-left: 35px;">误报解除</el-radio>
                            <el-radio :label="4" style="font-size: 16px;padding-left: 35px;">重新定义故障</el-radio>
                        </el-radio-group>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>


            <el-row v-if="selectedOption === 4" style="display:flex;flex-wrap:wrap;margin: 20px 20px;">
            <div style="width:100%;">
                <el-row>
                <el-col :span="24" style="margin-bottom: 10px;margin-left: 20px;padding-top: 20px;color: white;">
                    <el-form :model="form" :rules="rules" ref="form" style="color:white">
                    <el-form-item label="故障类型：" prop="faultType" style="color:red">
                        <el-select v-model="form.faultType" placeholder="请选择" size="default" clearable style="width:150px">
                        <el-option v-for="item in faultTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="故障说明:" prop="faultDescription" style="width: 90%;">
                        <el-input v-model="form.faultDescription" maxlength="128" type="textarea" :rows="4" placeholder="请输入故障说明"></el-input>
                    </el-form-item>

                    </el-form>
                </el-col>
                </el-row>
            </div>
            </el-row>


            <el-row>
                <el-col :span="24" style="text-align: center; height: 50px;">
                    <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
                    <el-button @click="handleClose" >取消</el-button>
                </el-col>
            </el-row>

        </ly-dialog2>
    </div>
</template>

<script>
    import {apiAlarmsUpdata,apiAlarmsById} from "@/api/api";
    import LyDialog2 from "@/components/dialog/dialog2";
    import {deepClone} from "@/utils/util";
    export default {
        components: {LyDialog2},
        emits: ['updataConfirm'],
        name: "faultHandle",
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',

                selectedOption:null,

                alarmInfo:{

                },
                faultTypeList:[
                    {id:0,name:'空'},
                    {id:1,name:'停机'},
                    {id:99,name:'其他故障'},
                    {id:100,name:'模拟事件'},
                    {id:101,name:'转子不对中'},
                    {id:102,name:'转子不平衡'},
                    {id:103,name:'轴弯曲'},
                    {id:104,name:'轴裂纹'},
                    {id:105,name:'轴承松动'},
                    {id:106,name:'滚动轴承故障'},
                    {id:107,name:'滑动轴承故障'},
                    {id:201,name:'UPS温度过高'},
                    {id:202,name:'UPS电源局部放电'},
                    {id:203,name:'UPS电源机械性故障'},
                    {id:301,name:'空调压缩机故障'},
                    {id:401,name:'变压器局部放电'},
                    {id:402,name:'变压器绕组形变'},
                    {id:403,name:'变压器部件松动'},
                    {id:404,name:'变压器直流偏磁'},
                    {id:901,name:'电流异常'},
                    {id:1001,name:'温度异常'},
                ],
                form : {
                    faultType : null,
                    faultDescription : null
                },
                rules: {  
                    faultType: [  
                        { required: true, message: '请选择一个选项', trigger: 'change' }  
                    ],
                    faultDescription: [
                        {required: true, message: '请输入故障描述',trigger: 'blur'}
                    ],  
                } ,
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible=false
                this.loadingSave=false
            },

            faultHandleFn(item,flag) {
                this.loadingTitle=flag
                this.dialogVisible=true

                this.selectedOption = null
                this.form.faultType = ""
                this.form.faultDescription = ""

                if(item){
                    this.alarmInfo = deepClone(item)
                }

                let alarmId = {
                    id : this.alarmInfo.id
                }
                apiAlarmsById(alarmId).then(async res => {
                    this.loadingSave = false
                    if (res.code === 200) {
                        if(res.data.state != 0){
                            this.selectedOption = res.data.state
                            if(res.data.processed_type == 0 || res.data.processed_type == null)
                                this.form.faultType = null
                            else
                                this.form.faultType = res.data.processed_type
                            this.form.faultDescription = res.data.processed_desc

                            this.alarmInfo = res.data
                        } 
                    } else {
                        this.$message.error(`获取告警信息失败`)
                    }
                }).catch(res => {  
                    this.loadingSave = false
                    this.$message.error(`获取告警信息失败：${res.msg}`)
                }); 
            },

            submitData() {
                if( this.selectedOption != null)
                {
                    if(this.selectedOption == 4){
                        this.$refs.form.validate((valid) => {  
                            if (valid) {  
                                this.loadingSave=true

                                var param = {
                                    id : this.alarmInfo.id,
                                    level: this.alarmInfo.level,
                                    state: this.selectedOption,
                                    processed_type: this.form.faultType,
                                    processed_desc: this.form.faultDescription
                                }

                                apiAlarmsUpdata(param).then(async res => {
                                    this.loadingSave = false
                                    if (res.code === 200) {
                                        this.handleClose()
                                        this.$emit('updataConfirm','comfirm')
                                        this.$message.success("告警处理更新成功！")
                                    } else {
                                        this.$message.error(`告警处理更新失败`)
                                    }
                                }).catch(res => {  
                                    this.loadingSave = false
                                    this.$message.error(`告警处理更新失败：${res.msg}`)
                                });                            

                            } 
                        });
                    }else{
                        this.loadingSave=true

                        var param = {
                            id : this.alarmInfo.id,
                            level: this.alarmInfo.level,
                            state: this.selectedOption,
                            processed_type: 0,
                        }

                        apiAlarmsUpdata(param).then(async res => {
                            this.loadingSave = false
                            if (res.code === 200) {
                                this.handleClose()
                                this.$emit('updataConfirm','comfirm')
                                this.$message.success("告警处理更新成功！")
                            } else {
                                this.$message.error(`告警处理更新失败`)
                            }
                        }).catch(res => {  
                            this.loadingSave = false
                            this.$message.error(`告警处理更新失败：${res.msg}`)
                        }); 

                    }
  
                }
            },

        }
    }
</script>

<style lang="scss">

.ly-dialog2{
    background: url("../../assets/bigscreen/alarm_handle.png") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;

    background-color: rgb(0,0,0,0);
    text-align: center;
    padding-top: 10px;
    .el-dialog__title {
        color: white;
    }
    .el-form-item__label{
        color: white;
    }
    .el-textarea__inner{
        color: white;
    }
    .el-input__inner{
        color: white;
    }
    --el-box-shadow: none;
}

</style>